import type {ReactElement} from 'react';
import React from 'react';
import {PosterMobileBigSeekbar} from '@Components/poster-editor/components/poster-mobile-big-seekbar/poster-mobile-big-seekbar';
import {POSTER_MOBILE_BIG_SEEK_BAR_HEIGHT} from '@Components/poster-editor/components/poster-mobile-big-seekbar/poster-mobile-big-seekbar.types';
import {useAppSelector} from '@/hooks';
import {isScaleAnimatingToFitToScreen} from '../../poster-editor-reducer';
import usePosterDimensions from '@Hooks/poster-editor/usePosterDimensions';
import {useIsCurrentPageVideo} from '@Hooks/poster-editor/useIsCurrentPageVideo';
import useWhiteboardContainerDimensions from '@Hooks/poster-editor/useWhiteboardContainerDimensions';
import {MobilePageSelectionModeState} from '@Components/poster-editor/poster-editor.types';

export function PostPosterElement(): ReactElement<any> | null {
  const isScaleAnimatingToFit = useAppSelector(isScaleAnimatingToFitToScreen);
  const isMobileVariant =
    useAppSelector((state) => {
      return state.posterEditor.isMobileVariant;
    }) || false;
  const whiteboardContainerDimensions = useWhiteboardContainerDimensions();
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });
  const isMobilePageSelectorModeActive = useAppSelector((state) => {
    return state.posterEditor.mobilePageSelectionModeState === MobilePageSelectionModeState.ACTIVE;
  });

  const posterDimension = usePosterDimensions();
  const isCurrentPageVideo = useIsCurrentPageVideo();

  const hidePosterMobileBigSeekbar = (): boolean => {
    if (isScaleAnimatingToFit) {
      return false;
    }

    return posterDimension.height + POSTER_MOBILE_BIG_SEEK_BAR_HEIGHT > whiteboardContainerDimensions.height;
  };

  if (!(isMobileVariant && isCurrentPageVideo && !isVersionHistoryModeActive)) {
    return null;
  }

  if (isMobilePageSelectorModeActive) {
    return null;
  }

  return <PosterMobileBigSeekbar setVisibiltyHidden={hidePosterMobileBigSeekbar()} />;
}
